import { axiosInstance, axiosFileBlob, live_instance, axiosFileBlob_live } from "../instance";


/**=================================================主题管理========================================================= */
// 获取主题列表
export const getTopicListApi = (params) => live_instance({method: 'get', url: `/vod-operation/theme/list`, params})

// 获取主题模板列表
export const getTemplateApi = () => live_instance({method: 'get', url: `/vod-operation/theme/template/list`, })

// 获取多语言列表
export const getlangI18nApi = (themeId) => live_instance({method: 'get', url: `/vod-operation/theme/text/list`, params:{themeId} })

// 获取所有语言列表
export const getLangOptionsApi = () => live_instance({method: 'get', url: `/vod-operation/language/list`, })

// 根据主题模板ID查询所有主题坑位
export const getRecommendationApi = (params) => live_instance({method: 'get', url: `/vod-operation/theme/template/item/list`, params })

// 添加主题
export const addThemeApi = (data) => live_instance({method: 'post', url: `/vod-operation/theme`, data, type: 'json' })

// 修改主题
export const editThemeApi = (data) => live_instance({method: 'put', url: `/vod-operation/theme`, data, type: 'json' })

// 删除主题
export const deleteThemeApi = (themeId) => live_instance({method: 'delete', url: `/vod-operation/theme`, params:{themeId} })

// 获取model选项列表
export const getModelListAPi = (pids, cids) => live_instance({method: 'get', url: `/vod-datasource/stb/model/options`, params:{pids, cids} })

// 获取品牌选项
export const getBrandListApi = (cids) => live_instance({method: 'get', url: `/vod-datasource/stb/brand/options`, params:{cids} })

// 获取平台选项
export const getPlatformListApi = (cids) => live_instance({method: 'get', url: `/vod-datasource/stb/platform/options`, params:{cids} })

/**=================================================运营方案管理======================================================== */
// 获取运营方案列表
export const getOperationPlanApi = (params) => live_instance({method: 'get', url: `/vod-operation/plan/list`, params})

// 获取运营方案绑定的主题列表
export const getRelationThemesApi = (params) => live_instance({method: 'get', url: `/vod-operation/plan/theme/list`, params})

// 删除运营方案
export const deleteOperationPlanApi = ({planId}) => live_instance({method: 'delete', url: `/vod-operation/plan`, params:{planId}})

// 添加运营方案
export const addOperationPlanApi = (data) => live_instance({method: 'post', url: `/vod-operation/plan`, data, type:'json'})

// 更新运营方案
export const editOperationPlanApi = (data) => live_instance({method: 'put', url: `/vod-operation/plan`, data, type:'json'})



/***==============================================终端品牌配置=============================================== */
// 获取agent切换列表配置
export const getTreminalMainBrandListApi = (params) => live_instance({method: 'get', url: `/agent/user-agent-switch/page`, params})

// 新增用户agent切换配置
export const addTreminalMainBrandApi = (data) => live_instance({method: 'post', url: `/agent/user-agent-switch`, data, type:'json'})

// 修改用户agent切换配置
export const updateTreminalMainBrandApi = (data) => live_instance({method: 'put', url: `/agent/user-agent-switch`, data, type:'json'})

// 删除用户agent切换配置
export const deleteTreminalMainBrandApi = (id) => live_instance({method: 'delete', url: `/agent/user-agent-switch/${id}` })

// 获取主品牌下拉选项
export const getMainBrandOptionsApi = (cid?) => live_instance({method: 'get', url: `/agent/main-agent/options`, params: {cid} }) 


/**===================================================定制风格========================================================= */
// 获取定制主品牌列表
export const getCustomerStyleApi = ({cid}) => live_instance({method: 'get', url: `/agent/customer-agent/list`, params:{cid}})

// 获取主品牌 UI
export const getMainBrandUIApi = () => live_instance({method: 'get', url: `/agent/customer-agent/ui/options` })

// 添加定制主品牌
export const addCusMainBrandListApi = (data) => live_instance({method: 'post', url: `/agent/customer-agent`, data, type: 'json'})

// 获取定制主品牌
export const getCusMainBrandApi = (customerMainAgentId) => live_instance({method: 'get', url: `/agent/customer-agent/${customerMainAgentId}` })

// 更新定制主品牌
export const editCusMainBrandListApi = (data) => live_instance({method: 'put', url: `/agent/customer-agent`, data, type: 'json'})

// 删除定制主品牌
export const deleteCusMainBrandApi = (customerMainAgentId) => live_instance({method: 'delete', url: `/agent/customer-agent/${customerMainAgentId}`, })

// 获取子品牌下拉列表
export const getCustomerSubAgentApi = (mainAgentIds) => live_instance({method: 'get', url: `/agent/sub-agent/options`, params:{mainAgentIds}})


/**=======================================================内容定价================================================================== */
// 查询品牌内容定价
export const getContentPriceListApi = (params) => live_instance({method: 'get', url: `/agent/content-pricing/config/page`, params})

// 新增品牌内容定价
export const addContentPriceListApi = (data) => live_instance({method: 'post', url: `/agent/content-pricing/config`, data, type: 'json'})

// 修改品牌内容定价
export const editContentPriceListApi = (data) => live_instance({method: 'put', url: `/agent/content-pricing/config`, data, type: 'json'})

// 删除品牌内容定价
export const deleteContentPriceListApi = (id) => live_instance({method: 'delete', url: `/agent/content-pricing/config/${id}` })

// 获取子品牌下拉列表
export const getSubBrandOptionsApi = (params) => live_instance({method: 'get', url: `/agent/sub-agent/options`, params })


/**==============================================================产品运营=============================================================== */
// 获取app下拉风格
export const getAppStyleOptionsApi = () => live_instance({method: 'get', url: `/agent/appStyle` })

// 获取主品牌及子品牌列表  
export const getMainSubAgentListApi = (params) => live_instance({method: 'get', url: `/agent/main-agent/list`, params })

// 获取主品牌的排序列表
export const getMainAgentSortApi = (cid) => live_instance({method: 'get', url: `/agent/main-agent/sequences`, params: {cid} })

// 创建主品牌
export const addMainAgentApi = (data) => live_instance({method: 'post', url: `/agent/main-agent`, data, type:'json' })

// 编辑主品牌
export const editMainAgentApi = (data) => live_instance({method: 'put', url: `/agent/main-agent`, data, type:'json' })

// 删除主品牌
export const deleteMainAgentApi = (mainAgentId) => live_instance({method: 'delete', url: `/agent/main-agent/${mainAgentId}`, })

// 根据主品牌id获取主品牌信息
export const getMainAgentByIdApi = (mainAgentId) => live_instance({method: 'get', url: `/agent/main-agent/${mainAgentId}`, })

// 获取子品牌的排序列表 
export const getSubAgentSortApi = (mainAgentId) => live_instance({method: 'get', url: `/agent/sub-agent/sequences`, params:{mainAgentId} })

// 创建子品牌
export const addSubAgentApi = (data) => live_instance({method: 'post', url: `/agent/sub-agent`, data, type:'json' })

// 编辑子品牌
export const editSubAgentApi = (data) => live_instance({method: 'put', url: `/agent/sub-agent`, data, type:'json' })

// 获取下拉选项
export const getOptionListApi = (typeName) => live_instance({method: 'get', url: `/agent/enum/options`, params: {typeName} })

// 获取子品牌信息
export const getSubAgentByIdApi = (subAgentId) => live_instance({method: 'get', url: `/agent/sub-agent/${subAgentId}`  })

// 删除子品牌
export const deleteSubAgentApi = (subAgentId) => live_instance({method: 'delete', url: `/agent/sub-agent/${subAgentId}`  })

// 关联子品牌
export const relationSubAgentApi = (data) => live_instance({method: 'post', url: `/agent/sub-agent/relation`, data, type:'json' })

// 解除关联子品牌
export const disassociateSubAgentApi = (subAgentId) => live_instance({method: 'delete', url: `/agent/sub-agent/relation`, params:{subAgentId}  })


/**=======================================================点播分类====================================================== */
// 查询分类列表
export const getVodCategoryApi = (params) => live_instance({method: 'get', url: `/vod-content/category/list`, params })

// 添加分类
export const addVodCategoryApi = (data) => live_instance({method: 'post', url: `/vod-content/category`, data, type:'json' })

// 编辑分类
export const editVodCategoryApi = (data) => live_instance({method: 'put', url: `/vod-content/category`, data, type:'json' })

// 删除分类
export const delVodCategoryApi = (id) => live_instance({method: 'delete', url: `/vod-content/category`, params: {id}  })

// 获取点播分类内容列表
export const getVodInfoListApi = (params) => live_instance({method: 'get', url: `/vod-content/category/program/list`, params  })

// 删除分类节目
export const removeVodInfoApi = (idList) => live_instance({method: 'delete', url: `/vod-content/category/program`, params:{idList},   })

// 分类节目按名称重新排序
export const sortByNameApi = (data) => live_instance({method: 'put', url: `/vod-content/category/program/rearrange`, data, type:'json'  })

// 变更分类节目顺序
export const changeSequenceVodInfoApi = (data) => live_instance({method: 'put', url: `/vod-content/category/program/sequence`, data, type:'json'   })

// 获取电影详情
export const getMovieDetailApi = (params) => live_instance({method: 'get', url: `/vod-datasource/search/movie/details`, params })

// 获取电视剧详情
export const getSeriesDetailApi = (params) => live_instance({method: 'get', url: `/vod-datasource/search/tv_series/details`, params })

// 获取节目详情 电影和剧集
export const getProgramInfoApi = (params) => live_instance({method: 'get', url: `/vod-content/program/info`, params })

// 获取连续剧列表
export const getDramaInfoApi = (params) => live_instance({method: 'get', url: `/vod-content/tv-season/media/list`, params })

// 获取节目内容列表
export const getMovieInfoApi = (params) => live_instance({method: 'get', url: `/vod-content/movie/media/list`, params })

// 获取系列片详情
export const getSeriesInfoApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series`, params })

// 获取系列片关联的分类
export const getAgentRelationCategorysApi = (params) => live_instance({method: 'get', url: `/vod-content/category/getAgentRelationCategory`, params })

// 获取添加点播的节目列表
export const getVodChannelListApi = (params) => live_instance({method: 'get', url: `/vod-content/program/page`, params })
 
// 获取点播分类属性下拉列表 
export const getVodGenresOptionsApi = (params) => live_instance({method: 'get', url: `/vod-datasource/genres/options`, params })

// 添加节目到点播分类
export const addVodToCategoryApi = (data) => live_instance({method: 'post', url: `/vod-content/category/program`, data, type: 'json' })

// 付费影片编辑
export const paymentSettingApi = (data) => live_instance({method: 'put', url: `/vod-content/category/program/payment`, data, type: 'json' })

// 获取点播分类属性
export const getVodGenresListApi = (params) => live_instance({method: 'get', url: `/vod-datasource/genres`, params })

// 获取系列片列表（添加计划）
export const getSeriesListApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series/listForAddPlan`, params })

// 批量修改付费功能
export const updatePaymentFormApi = (data) => live_instance({method: 'put', url: `/vod-content/program/paymentForm`, data, type: 'json' })


/**============================================================推荐管理====================================================== */
// 获取vodPlus方案
export const getVodPlusListApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/plan/list`, params })

// 获取子品牌推荐方案
export const getOperationPlanThemeApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/plan/theme/list`, params })

// 获取子品牌所有推荐位
export const getOperationPlanThemeAllItemApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/theme/item/list`, params })

// 预览功能
export const getRecommendPreview = (params) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/plan/theme/preview`, params })

// 获取运营方案下拉列表
export const getOperationPlanListApi = () => live_instance({method: 'get', url: `/vod-operation/plan/listAll` })

// 添加vodPlus推荐方案
export const addVodPlusApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/plan/add`, data, type: 'json' })

// 编辑vodPlus推荐方案
export const editVodPlusApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/plan/edit`, data, type: 'json' })

// 删除vodPlus推荐方案
export const deleteVodPlusApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/plan/delete`, params })

// 获取推荐计划
export const getOperationPlanThemeItemApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/theme/item/schedule/list`, params })

// 上传推荐位的图片
export const uploadVodplusThemeItemPictureApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/schedule/picture`, data, type: 'json' })

// 编辑主题的排序 终端审核状态 执行状态
export const editOperationPlanBusinessThemeApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/plan/theme/edit`, data, type: 'json' })

// 添加子推荐位
export const addVodplusThemeSubitemApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/addSubItem`, data, type: 'json' })

// 删除推荐位计划  看看接口是什么
// export const deleteVodplusThemeSubitemApi = (id) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/theme/item/schedule/delete`, params: {id} })

async function convertFormDataToJson(formData) {
  const json = {};

  // 遍历 FormData
  for (const [key, value] of formData.entries()) {
    if (value instanceof File || value instanceof Blob) {
      // 将图片数据保留为二进制
      json[key] = await convertFileToBinary(value);
    } else {
      // 非二进制数据直接保存
      json[key] = value;
    }
  }

  return json;
}

function convertFileToBinary(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      // 读取成功，返回二进制数据
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file); // 将文件读取为 ArrayBuffer
  });
}


// 添加运营主题
export const addOperationPlanBusinessThemeApi = (data) => {
  console.log('data', data)
  let paramsKeys = ['parentId', 'operationThemeName', 'status', 'id', 'scheduleStartTime', 'scheduleEndTime', 'backgroundImgUrl', 'region', 'names', 'remark', 'backgroundImgUrl', 'backgroundImgFile']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'backgroundImgFile') {
      formData.append('backgroundImgFile', data[key][0]?.raw)
    }
    else if(key === 'names') {
      // 数组对象转成字符串
      formData.append(key, JSON.stringify(data[key]) )
    }
    else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return live_instance({
    method: 'post',
    url: '/vod-operation/recommend/vodplus/plan/theme/business/add',
    data: formData,
    type: 'upload',
    noRepetition: true,
  })
}

// 删除运营主题
export const deleteOperationPlanBusinessThemeApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/plan/theme/business/delete`, params })

// 编辑运营主题
export const editOperationPlanBusinessThemesApi = (data) => {
  let paramsKeys = ['parentId', 'operationThemeName', 'status',  'id', 'names', 'scheduleStartTime', 'scheduleEndTime', 'region', 'remark', 'backgroundImgUrl', 'backgroundImgFile']
  let formData = new FormData()
  for (let key in data) {
    if (key === 'backgroundImgFile') {
      formData.append('backgroundImgFile', data[key][0]?.raw)
    }
    else if(key === 'names') {
      // 数组对象转成字符串
      formData.append(key, JSON.stringify(data[key]) )
    }
    else {
      if (paramsKeys.includes(key)) formData.append(key, data[key])
    }
  }
  return  live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/plan/theme/business/edit`, data: formData, type:'upload', noRepetition: true, })
}

// 上传推荐位图片
export const uploadVodplusCategoryPictureApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/category/picture/upload`, data, type: 'json' })

// 编辑子推荐位信息
export const editVodplusThemeSubitemApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/edit`, data, type: 'json' })

// 复制子推荐位信息
export const copyVodplusThemeSubitemApi = (params) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/theme/item/copySubItem`, params})

// 删除推荐位信息
export const deleteVodplusThemeSubitemApi = (id) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/theme/item/delete`, params: {id} })

// 添加推荐计划
export const addVodplusThemeItemPlanApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/schedule/add`, data, type: 'json' })

// 编辑推荐计划
export const editVodplusThemeItemPlanApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/schedule/edit`, data, type: 'json' })

// 删除推荐计划(批量)
export const deleteVodplusThemeItemPlanApi = (data) => live_instance({method: 'post', url: `/vod-operation/recommend/vodplus/theme/item/schedule/delete`, data, type:'json' })

// 获取主题的多语言列表(点复制和编辑的时候使用)
export const getThemesLangaugeListApi = (vodplusOperationPlanThemeId) => live_instance({method: 'get', url: `/vod-operation/recommend/vodplus/plan/theme/text/list`, params: {vodplusOperationPlanThemeId} })


/**=========================================================演员================================================== */
// 查询演员列表
export const getActorListApi = (params) => live_instance({method: 'get', url: `/vod-datasource/cast/list`, params  })

// 获取演员下拉列表
export const getActorOptionsApi = (params) => live_instance({method: 'get', url: `/vod-datasource/cast/options`, params  })

// 删除演员
export const deleteActorApi = (id) => live_instance({method: 'delete', url: `/vod-datasource/cast`, params: {id}  })

// 获取演员详情
export const getActorInfoApi = (id) => live_instance({method: 'get', url: `/vod-datasource/cast`, params: {id}  })

// 添加演员||导演
export const addActorOrDirectorApi = (data) => live_instance({method: 'post', url: `/vod-datasource/cast`, data, type: 'json'  })

// 更新演员信息
export const updateActorInfoApi = (data) => live_instance({method: 'put', url: `/vod-datasource/cast`, data, type: 'json'  })



/**=========================================================系列影片======================================================== */
// 获取系列影片列表
export const getProgramSetListApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series/list`, params  })

// 批量系列影片上下线
export const programSetStatusApi = (data) => live_instance({method: 'put', url: `/vod-content/video-series/release-status`, data, type:'json'  })

// 获取系列影片关联的分类
export const getProgramRelationCategoryApi = (params) => live_instance({method: 'get', url: `/vod-content/category/relation`, params  })

// 导出系列影片
export const exportProgramSetApi = (params) => axiosFileBlob_live({method: 'get', url: `/vod-content/video-series/export`, params  })

// 获取系列影片列表(列表按钮点击)
export const getAddProgramInfoApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series/program/list`, params  })

// 移除系列影片列表的影片
export const deleteSetProgramIdsApi = (data) => live_instance({method: 'delete', url: `/vod-content/video-series/program`, data, type:'json'  })

// 修改系列影片列表的排序
export const editSetSequenceApi = (data) => live_instance({method: 'put', url: `/vod-content/video-series/program/sequence`, data, type:'json'  })

// 添加影片到系列影片列表
export const addProgramInfoApi = (data) => live_instance({method: 'post', url: `/vod-content/video-series/program`, data, type:'json'  })

// 新增系列片
export const addProgramSetApi = (data) => live_instance({method: 'post', url: `/vod-content/video-series`, data, type:'json'  })

// 获取品牌关联的点播分类树
export const getAgentCategoryApi = (params) => live_instance({method: 'get', url: `/vod-content/category/getAgentCategoryTree`, params  })

// 获取系列片详情
export const getProgramSetByIdApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series`, params  })

// 删除系列片
export const deleteProgramSetApi = (data) => live_instance({method: 'delete', url: `/vod-content/video-series`, data, type:'json'  })

// 修改系列片
export const editProgramSetApi = (data) => live_instance({method: 'put', url: `/vod-content/video-series`, data, type:'json'  })

// 获取系列片下拉列表
export const getProgramSetApi = (params) => live_instance({method: 'get', url: `/vod-content/video-series/option`, params  })



/**===========================================================点播内容================================================================= */
// 获取点播审核列表
export const getReviewListApi = (params) => live_instance({method: 'get', url: `/vod-content/program/page`, params  })

// 导出点播列表(影片管理)
export const exportProgramInfoApi = (params) => axiosFileBlob_live({method: 'get', url: `/vod-content/program/export`, params, timeout: 1800000  })

// 更改节目审核状态
export const auditStatusApi = (data) => live_instance({method: 'put', url: `/vod-content/program/auditStatus`, data, type:'json'  })

// 更改节目上下线状态
export const releaseStatusApi = (data) => live_instance({method: 'put', url: `/vod-content/program/releaseStatus`, data, type:'json'  })

// 审核: 影片审核 单个/批量
export const batchAuditStatusApi = (data) => live_instance({method: 'put', url: `/vod-content/program/play/auditStatus`, data, type:'json'  })

// 批量操作 批量上线下线
export const batchReleaseStatusApi = (data) => live_instance({method: 'put', url: `/vod-content/program/play/releaseStatus`, data, type:'json'  })

// 批量删除节目
export const deleteVodInfoApi = (params) => live_instance({method: 'delete', url: `/vod-content/program`, params,   })

// 获取字幕列表
export const getSubtitleInfoApi = (params) => live_instance({method: 'get', url: `/vod-datasource/subtitle/getTranslatedSubtitle`, params  })

// 提交翻译
export const translateSubtitlesApi = (data) => live_instance({method: 'post', url: `/vod-datasource/translate/subtitles`, data, type:'json'  })

// 获取字幕文件内容
export const getSubtitleDataApi = (params) => live_instance({method: 'get', url: `/vod-datasource/subtitle/getSubtitleData`, params  })

// 更新字幕文件
export const updateSubtitleFileApi = (data) => live_instance({method: 'post', url: `/vod-datasource/subtitle/update`, data, type: 'json'  })

// 搜索字幕
export const searchSubtitleApi = (params) => live_instance({method: 'get', url: `/vod-datasource/subtitle/search`, params  })

// 电影 列表添加源地址
export const editMoviePlayUrlApi = (data) => live_instance({method: 'put', url: `/vod-content/movie/medias`, data, type: 'json'  })

// 更新节目内容列表
export const updateMovieInfoApi = (data) => live_instance({method: 'put', url: `/vod-content/movie/media`, data, type: 'json'  })

// 添加剧集
export const addSeriesEpisodeApi = (data) => live_instance({method: 'put', url: `/vod-content/tv-season/episodes`, data, type: 'json'  })

// 添加剧集
export const addTvSeasonMediaApi = (data) => live_instance({method: 'put', url: `/vod-content/tv-season/media`, data, type: 'json'  })

// 电视剧中导入续集
export const importSeriesEpisodeApi = (data) => live_instance({method: 'post', url: `/vod-content/program/media/import`, data, type: 'upload', duration: 5000, timeout: 1800000  })

// 搜索电影
export const searchMovieApi = (params) => live_instance({method: 'get', url: `/vod-datasource/search/movie`, params  })

// 搜索电视剧
export const searchTvSeasonApi = (params) => live_instance({method: 'get', url: `/vod-datasource/search/tv_series`, params  })

// 新增节目
export const addProgramApi = (data) => live_instance({method: 'post', url: `/vod-content/program`, data, type:'json'  })

// 编辑节目
export const editProgramApi = (data) => live_instance({method: 'put', url: `/vod-content/program`, data, type:'json'  })

// 影片关联云盘账号
export const linkCloudDiskToChannel = (data) => live_instance({method: 'post', url: `/vod-content/cloudDisk/programRelation`, data, type:'json'  })

// 取消关联云盘账号
export const unBindCloudDiskToChannel = (params) => live_instance({method: 'delete', url: `/vod-content/cloudDisk/programRelation`, params,    })

// 获取海报列表
export const getPosterListApi = (params) => live_instance({method: 'get', url: `/vod-datasource/poster/list`, params  })

// 获取电视剧季数
export const getTVSeasonOptionsApi = (tvSeriesId) => live_instance({method: 'get', url: `/vod-content/tv-series/season/options`, params: {tvSeriesId}  })

// 获取季下面的剧集数
export const getEpisodeOptionsApi = (tvSeasonId) => live_instance({method: 'get', url: `/vod-content/tv-series/season/episodes/options`, params: {tvSeasonId}  })

// 获取片源语言选项
export const getAudioLangOptionsApi = (tvSeriesId) => live_instance({method: 'get', url: `/vod-content/tv-series/audio/language/options`, params: {tvSeriesId}  })

// 获取节目详情（先导入再导出excel）
export const exportProgramDetailApi = (data, params) => live_instance({method: 'post', url: `/vod-content/program/export/trailer`,  responseType:'blob',
  params, data, type: 'upload'  })

/**==================================================================终端审核权限===================================================================== */
// 获取终端审核权限列表
export const getTerminalCheckApi = (params) => live_instance({method: 'get', url: `/agent/terminal-check/page`, params  })

// 新增终端
export const addTerminalCheckApi = (data) => live_instance({method: 'post', url: `/agent/terminal-check`, data, type: 'json'  })

// 编辑终端
export const editTerminalCheckApi = (data) => live_instance({method: 'put', url: `/agent/terminal-check`, data, type: 'json'  })

// 删除终端
export const deleteTerminalCheckApi = (terminalCheckId) => live_instance({method: 'delete', url: `/agent/terminal-check/${terminalCheckId}`   })

// 更新终端状态
export const switchStatusApi = (params) => live_instance({method: 'put', url: `/agent/terminal-check/status`, params  })



/**==============================================================运营商管理==================================================================================== */
// 获取运营商列表
export const getOperatorListApi = (params) => live_instance({method: 'get', url: `/agent/operator/list`, params  })

// 添加运营商
export const addOperatorApi = (data) => live_instance({method: 'post', url: `/agent/operator`, data, type: 'json'  })

// 删除运营商
export const deleteOperatorApi = (params) => live_instance({method: 'delete', url: `/agent/operator`, params  })

// 更新运营商
export const editOperatorApi = (data) => live_instance({method: 'put', url: `/agent/operator`, data, type: 'json'  })

// 获取网盘下拉框
export const getCloudDiskOptionsApi = (params) => live_instance({method: 'get', url: `/vod-content/cloudDisk/option`, params, type: 'json'  })



/**============================================================系统用户权限==================================================================== */
// 查看系统用户权限关联权限
export const checkAgentApi = (params) => live_instance({method: 'get', url: `/agent/agent-permission/tree`, params  })

// 系统用户权限关联权限回显
export const getRelationAgentApi = (params) => live_instance({method: 'get', url: `/agent/agent-permission`, params  })

// 系统用户权限关联权限
export const addRelationAgentApi = (data) => live_instance({method: 'post', url: `/agent/agent-permission`, data, type: 'json'  })

// 获取下载模板
export const getDocumentDownloadApi = () => live_instance({method: 'get', url: `/vod-content/template`  })


/**===================================================点播批量管理============================================= */
// 查询点播节目的数量
export const vodSearchCountApi = (params) => live_instance({method: 'get', url: `/vod-content/program/content/getMatchedContentPrefixCount`, params  })

// 替换点播
export const replaceVodContentApi = (params) => live_instance({method: 'put', url: `/vod-content/program/content/replaceContentPrefix`, params,  })


/**======================================================点播播放授权================================================== */
/**查询vod播放授权配置 */
export const getVodCookieListApi = (params) => live_instance({method: 'get', url: `/vod-operation/cookie/page`, params }) 

/**新增vod播放授权配置 */
export const addVodCookieApi = (data) => live_instance({method: 'post', url: `/vod-operation/cookie`, data, type: 'json' })

/**编辑vod播放授权配置 */
export const editVodCookieApi = (data) => live_instance({method: 'put', url: `/vod-operation/cookie`, data, type: 'json' })

/**删除vod播放授权配置 */
export const deleteVodCookieApi = (id) => live_instance({method: 'delete', url: `/vod-operation/cookie/${id}`,   })


/**===================================================点播播放服务器设置============================================================ */
/**查询vod播放服务器 */
export const getVodServerListApi = () => live_instance({method: 'get', url: `/vod-operation/play/domain/list`,  }) 

/**新增vod播放服务器 */
export const addVodServerApi = (data) => live_instance({method: 'post', url: `/vod-operation/play/domain`, data, type: 'json' })

/**编辑vod播放服务器 */
export const editVodServerApi = (data) => live_instance({method: 'put', url: `/vod-operation/play/domain`, data, type: 'json' })

/**删除vod播放服务器 */
export const deleteVodServerApi = (id) => live_instance({method: 'delete', url: `/vod-operation/play/domain/${id}`,   })





